import apiService from './api'
import { buildEndpoint } from '../utils/apiUtils'

export interface Branch {
  id: number
  name: string
  image: string | null
  phone: string
  area: {
    id: number
    name: string
    city: {
      id: number
      name: string
      country: {
        id: number
        name: string
        code: string
        currency: string
      }
    }
  }
  workingFrom: string
  workingTo: string
  location: {
    type: string
    coordinates: [number, number]
  }
  descriptiveAddress: string
  polygon: {
    type: string
    coordinates: number[][][]
  }
  Active: boolean
  Busy: boolean
  isOpen: boolean
  deliveryOption: number
  carOption: number
  branchOption: number
}

export interface BranchesResponse {
  message: string
  descriptiveMessage: string
  data: {
    collection: Branch[]
    meta: {
      total: number
      perPage: number
      currentPage: number
      lastPage: number
    }
  }
}

/**
 * Fetch all branches
 */
export async function fetchBranches(): Promise<Branch[]> {
  try {
    const response = await apiService.get(buildEndpoint('/cashier/branches/'))

    // Handle API response structure
    let branchesData: Branch[] = []
    
    if (response.data) {
      if (response.data.data) {
        // Handle nested data structure: data.data.collection
        if (response.data.data.collection && Array.isArray(response.data.data.collection)) {
          branchesData = response.data.data.collection
        } else if (Array.isArray(response.data.data)) {
          branchesData = response.data.data
        }
      } else if (response.data.collection && Array.isArray(response.data.collection)) {
        branchesData = response.data.collection
      } else if (Array.isArray(response.data)) {
        branchesData = response.data
      }
    }

    return branchesData
  } catch (error) {
    throw error
  }
}



